/*       */

import { gql } from '@apollo/client';
import relationDefinitionsCommonQueryFields from 'graphql/entities/relationships/relationDefinitionsCommonQueryFields';

export default gql`
    mutation addRelationDefinitionClassesMutation($id: ID!, $classes: [ID]!) {
        result: relationDefinitionAddClasses(id: $id, classes: $classes) {
            ${relationDefinitionsCommonQueryFields}
        }
    }
`;
